import footerLogo from './../../resources/images/footer-logo.png';

import './index.scss';

function Footer() {
    return (
        <div className="footer">
            <div className="container">
                <div className="footer-info-col">
                    <a href="#" className="footer-logo"><img src={footerLogo} alt="" /></a>
                    <p className="footer-info-paragraph">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ultrices arcu ipsum nunc elementum dictumst tempor arcu eget.</p>
                    <p className="footer-copyright">(c) 2022 All rights reserved</p>
                </div>
                <div className="footer-social-links-wrapper">
                    <h5 className="footer-social-links-title">keep in touch</h5>
                    <ul className="footer-social-links">
                        <li className="footer-social-link">
                            <a href="https://www.facebook.com/TheSpringNews-100126145945813/" target="_blank" className="bme-icon-facebook">facebook</a>
                        </li>
                        <li className="footer-social-link">
                            <a href="https://www.instagram.com/thespringnews/" target="_blank" className="bme-icon-instagram">instagram</a>
                        </li>
                        <li className="footer-social-link">
                            <a href="https://twitter.com/TheSpringNews" target="_blank" className="bme-icon-twitter">twitter</a>
                        </li>
                        <li className="footer-social-link">
                            <a href="https://www.linkedin.com/company/springnews/" target="_blank" className="bme-icon-linkedin">linkedin</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Footer;